/* eslint-disable react-native/no-color-literals */
import React, { FC } from "react"
import { ElementType, exitWalkthrough, goToWalkthroughElementWithId, nullElement } from "react-native-walkthrough"
import { View } from "native-base"
import { Text } from "../components/text/text"
import { Appearance, TouchableOpacity, ViewStyle } from "react-native"
import { Button, JalaIcon } from "../components"
import { translate } from "../i18n"
import JalaAnalytic from "../utils/jala-analytic"
import { color } from "../theme"

const CLOSE_ICON: ViewStyle = {
  marginLeft: 5,
  width: "10%",
  alignItems: "flex-end"
}

const Content: FC<{
  colorScheme?: "light" | "dark",
  text: string,
  order?: number,
  total?: number,
  nextText?: string,
  onNext?: () => void,
  onExit?: () => void
}> = function Content(props) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    text, order, total, nextText, onNext, onExit
  } = props

  return <View>
    <View flexDirection="row" alignItems="flex-start" justifyContent="space-between">
      <View width="90%">
        <Text text={text} preset="textBase" marginBottom="8px" colorScheme={colorScheme}  />
      </View>
      <TouchableOpacity onPress={onExit} style={CLOSE_ICON}>
        <JalaIcon name="close" size={20} color={color.palette.gray800} />
      </TouchableOpacity>
    </View>
    <View flex={1} height="30px" flexDirection="row" alignItems="center" justifyContent="space-between">
      <Text text={`${order}${total ? `/${total}` : ""}`} preset="xs" colorScheme={colorScheme} />
      <Button
        testID="jala:id/next-button"
        text={nextText || translate("common.next")}
        textPreset="caption2"
        preset="primarySmall"
        colorScheme={colorScheme}
        onPress={onNext}
      />
    </View>
  </View>
}

export default (data?: any, onExit?: () => void) => {
  return data && data.filter((v) => v).map((value, index, array) => ({
    ...value,
    tooltipProps: {
      allowChildInteraction: false,
      ...((index < (array.length - 1)) ? {} : { onClose: () => undefined }),
      tooltipStyle: { left: 0, right: 0, marginLeft: "auto", marginRight: "auto" },
      ...value.tooltipProps,
    },
    content: <Content
      text={value.content}
      order={index + 1}
      total={array.length}
      nextText={!array[index + 1] ? translate("common.done") : undefined}
      onNext={() => {
        if (array[index + 1]) {
          JalaAnalytic.log('Mobile App: Form Coachmark - finish', { id: value.id });
          goToWalkthroughElementWithId(array[index + 1]?.id || nullElement.id)
        }
        else {
          JalaAnalytic.log('Mobile App: Form Coachmark - finish', { id: value.id })
          onExit && onExit()
          exitWalkthrough()
        }
      }}
      onExit={() => {
        JalaAnalytic.log('Mobile App: Form Coachmark - finish', { id: value.id })
        onExit && onExit()
        exitWalkthrough()
      }}
    />,
  })) as Array<ElementType>
}
